// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".login{min-width:400px;background-color:#fff;padding:1em 0}", "",{"version":3,"sources":["webpack://./src/app/components/login/style.scss"],"names":[],"mappings":"AAAA,OACI,eAAA,CACA,qBAAA,CACA,aAAA","sourcesContent":[".login {\n    min-width: 400px;\n    background-color: #fff;\n    padding: 1em 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
